import {
    create
} from "zustand";
import api from "../../../api/axios";
import {
    message
} from "antd";

export const useService = create((set, get) => ({

    services: [],


    regions: [],
    districts: [],
    myBusiness: null,
    st: [],
    latlong: [41.311081, 69.240562],
    setLatlong: (latlong) => set({
        latlong
    }),
    sdistricts: [],
    file: [],
    setFile: (file) => set({file}),


    dsc: "",
    setDsc: (dsc) => set({
        dsc
    }),
    submitting: false,
    setSubmitting: (submitting) => set({
        submitting
    }),

    // Methods


    start: () => {
        Promise.all([
            api.get("/sdata"),
            api.get('/businesses/my/' + JSON.parse(localStorage.getItem('user')).id)
        ]).then(([sdataRes, bizRes]) => {
            set({
                regions: sdataRes.data.regions || []
            });
            set({
                districts: sdataRes.data.districts || []
            });
            set({
                myBusiness: bizRes.data.data
            });
            set({
                st: sdataRes.data.stype || []
            });
            localStorage.setItem('mybusiness', JSON.stringify(bizRes.data.data));
        }).catch(err => {
            console.error("Data load error:", err);
            message.error("Ma'lumotlarni yuklashda xatolik yuz berdi");
        });
    },

    handleChangeRegion: (value) => {
        set((state) => ({
            sdistricts: state.districts.filter(d => d.regions_id === value)
        }));
        let sreg = get().regions.find(r => r.id === value);
        if (sreg && sreg.lat && sreg.long) {
            set({
                latlong: [sreg.lat, sreg.long]
            });
        }
    },
    handleRemoveImage: (index) => {
        set({file:''});
    },



    // REQUESTS


    getSerices: () => {
        api.get('/services').then(res => {
            set({
                services: res.data.services
            });
        }).catch(err => {
            console.error("Services load error:", err);
            message.error("Xizmatlarni yuklashda xatolik yuz berdi");
        });
    },

    deleteService: (id) => {
        return api.delete(`/services/${id}`).then(() => {
            message.success("Xizmat muvaffaqiyatli o'chirildi");
            set((state) => ({ services: state.services.filter(s => s.id !== id) }));
            return true;
        }).catch(err => {
            console.error("Service delete error:", err);
            message.error(err.response?.data?.message || "Xizmatni o'chirishda xatolik yuz berdi");
            return false;
        });
    },



    handleSubmit: (values, form) => {
        let business = JSON.parse(localStorage.getItem('mybusiness'));
        if (!business?.id) {
            message.error("Avval korxona ma'lumotlarini saqlang!");
            return;
        }

        set({
            submitting: true
        });
        values.lat = String(get().latlong[0]);
        values.long = String(get().latlong[1]);
        values.desc = get().dsc;
        values.bussiness_id = business.id;
        values.file = get().file

        api.post('services', values).then(res => {
            const serviceId = res.data?.data?.id || res.data?.id;
            // setCurrentServiceId(serviceId);
            message.success("Xizmat muvaffaqiyatli yaratildi!");
            form.resetFields()
            get().getSerices()
            window.location.href = '/provider/services/service/' + res.data.data.id
            
        }).catch(err => {
            console.error(err);
            message.error("Xizmatni saqlashda xatolik yuz berdi");
        }).finally(() => set({
            submitting: false
        }));
    }
}))